/**
 * Module: phone
 * Role: Pure utility functions for Russian phone number formatting (+7 prefix mask).
 * Uses: nothing (pure functions, zero dependencies)
 * Used by: PhoneInput atom, RequisitesScreen
 * Glossary: ai/glossary/buyer.md
 */

/**
 * Extracts up to 10 national digits from arbitrary input string/paste.
 * Country-code dedup: a leading 7 or 8 (country code / repeat of fixed +7) is stripped.
 * RU mobile always starts with 9, so slicing leading 7/8 is safe.
 */
export function extractNationalDigits(raw: string): string {
  let digits = raw.replace(/\D/g, '');
  if (digits.length > 0 && (digits[0] === '7' || digits[0] === '8')) {
    digits = digits.slice(1);
  }
  return digits.slice(0, 10);
}

/**
 * Progressive format for display: '+7 (903) 754-87-99' (as user types).
 * Always returns at least '+7'.
 */
export function formatRuPhone(national: string): string {
  const d = national.slice(0, 10);
  let out = '+7';
  if (d.length > 0) out += ' (' + d.slice(0, 3);
  if (d.length >= 3) out += ')';
  if (d.length > 3) out += ' ' + d.slice(3, 6);
  if (d.length > 6) out += '-' + d.slice(6, 8);
  if (d.length > 8) out += '-' + d.slice(8, 10);
  return out;
}

/**
 * Canonical value for backend: '+7XXXXXXXXXX' when 10 digits present,
 * partial '+7' + digits for incomplete input, empty string for no input.
 */
export function toCanonicalPhone(national: string): string {
  return national ? '+7' + national : '';
}
